import { render, staticRenderFns } from "./event_list.vue?vue&type=template&id=57d8a0e2&"
import script from "./event_list.vue?vue&type=script&lang=js&"
export * from "./event_list.vue?vue&type=script&lang=js&"
import style0 from "./event_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports